import { render } from "./item_page.vue?vue&type=template&id=974dfc6c"
import script from "./item_page.vue?vue&type=script&lang=js"
export * from "./item_page.vue?vue&type=script&lang=js"

import "./item_page.vue?vue&type=style&index=0&id=974dfc6c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__